/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var FooterValidation = document.getElementById("newsletter_fotter__submit_btn");
var NewslatterValidation = document.getElementById("newsletter_fotter__submit_btn_1");
var RegisterValidation = document.getElementById("register__submit_btn");
var ContactValidation = document.getElementById("contact__submit_btn");
var SidecartValidation = document.getElementById("sidecart__submit_btn");
var CartValidation = document.getElementById("cart__submit_btn");
var FooterValidationForm = document.getElementById("footer-newsletter");
var RegisterValidationForm = document.getElementById("create_customer");
var ContactValidationForm = document.getElementById("contact_form");

function displayNewslatterValidation(event) {
    event.preventDefault();
    var Checkbox = document.getElementById("agree_ck_1");
    var Tooltip = document.getElementById("check_tooltip_1");  
    var CheckboxValue = Checkbox.checked;
    if(CheckboxValue == true){
      Checkbox.classList.remove("not-selected");
      Tooltip.style.display = "none";
      FooterValidationForm.submit();
    }else{
      Checkbox.classList.add("not-selected");
      Tooltip.style.display = "block";
      return false;
    }  
  }
if (NewslatterValidation != null){
  NewslatterValidation.onclick = displayNewslatterValidation;

  document.getElementById("agree_ck_1").addEventListener('change', function(){
    document.getElementById("check_tooltip_1").style.display = "none";
  });
} 

//Footer Newsletteer Form Submit

function displayFooterValidation(event) {
  event.preventDefault();
  var Checkbox = document.getElementById("agree_ck");
  var Tooltip = document.getElementById("check_tooltip");  
  var CheckboxValue = Checkbox.checked;
  if(CheckboxValue == true){
    Checkbox.classList.remove("not-selected");
    Tooltip.style.display = "none";
    FooterValidationForm.submit();
  }else{
    Checkbox.classList.add("not-selected");
    Tooltip.style.display = "block";
    return false;
  }  
}
if (FooterValidation != null){
  FooterValidation.onclick = displayFooterValidation;
  document.getElementById("agree_ck").addEventListener('change', function(){
    document.getElementById("check_tooltip").style.display = "none";
  });
}  
//Register Form Submit

function displayRegisterValidation(event) {
  event.preventDefault();
  var Checkbox = document.getElementById("register_agree");
  var Tooltip = document.getElementById("register_tooltip");  
  var CheckboxValue = Checkbox.checked;
  if(CheckboxValue == true){
    Checkbox.classList.remove("not-selected");
    Tooltip.style.display = "none";
    RegisterValidationForm.submit();
  }else{
    Checkbox.classList.add("not-selected");
    Tooltip.style.display = "block";
    return false;
  }  
}
if (RegisterValidation != null){
  RegisterValidation.onclick = displayRegisterValidation;
  document.getElementById("register_agree").addEventListener('change', function(){
    document.getElementById("register_tooltip").style.display = "none";
  });
} 
//Contact Form Submit

function displayContactValidation(event){
  event.preventDefault();
  var Checkbox = document.getElementById("contact_agree");
  var Tooltip = document.getElementById("contact_tooltip");  
  var CheckboxValue = Checkbox.checked;
  if(CheckboxValue == true){
    Checkbox.classList.remove("not-selected");
    Tooltip.style.display = "none";
    ContactValidationForm.submit();
  }else{
    Checkbox.classList.add("not-selected");
    Tooltip.style.display = "block";
    return false;
  }  
}
if (ContactValidation != null){
  ContactValidation.onclick = displayContactValidation;  
  document.getElementById("contact_agree").addEventListener('change', function(){
    document.getElementById("contact_tooltip").style.display = "none";
  });
}

//SideCart Form Submit

function displaySidecartValidation(event) {
  if(event) event.preventDefault();
  var Checkbox = document.getElementById("cart_agree");
  var Tooltip = document.getElementById("sidecart_tooltip");  
  var CheckboxValue = Checkbox.checked;
  if(CheckboxValue == true){
    Checkbox.classList.remove("not-selected");
    Tooltip.style.display = "none";
    window.location.href = "/checkout"
}else
{
  Checkbox.classList.add("not-selected");
  Tooltip.style.display = "block";
  return false;
}  
}
if (SidecartValidation != null){
  SidecartValidation.onclick = displaySidecartValidation;
} 
//Cart Form Submit
if (CartValidation != null){
function displayCartValidation(event) {
    event.preventDefault();
    var Checkbox = document.getElementById("cart_agree_1");
    var Tooltip = document.getElementById("cart_tooltip");  
    var CheckboxValue = Checkbox.checked;
    if(CheckboxValue == true){
      Checkbox.classList.remove("not-selected");
      Tooltip.style.display = "none";
      window.location.href = "/checkout"
    }else{
      Checkbox.classList.add("not-selected");
      Tooltip.style.display = "block";
      return false;
 }  
}
 CartValidation.onclick = displayCartValidation;
}
window.addEventListener("click", function(event){
  if(event.target.classList.contains("Cart__Checkout")){
    displaySidecartValidation(event);
    return;
}
if(event.target.getAttribute("id") == "cart_agree_1" || event.target.getAttribute("id") == "cart_agree"){
    if(event.target.checked){
      document.getElementById("cart_tooltip") ? document.getElementById("cart_tooltip").style.display = "none" : null;
      document.getElementById("sidecart_tooltip") ? document.getElementById("sidecart_tooltip").style.display = "none" : null;   
    }else{
      document.getElementById("cart_tooltip") ? document.getElementById("cart_tooltip").style.display = "block" : null;
      document.getElementById("sidecart_tooltip") ? document.getElementById("sidecart_tooltip").style.display = "block" : null; 
    }
    return;
}
});